import { InjectionToken } from '@angular/core';

export const AUTH0_READY = new InjectionToken<boolean>('auth0.ready');

